<div class="designer-menu-bar">
    <div class="nodes-bar">
        <div #stepDraggableElement draggable="true" aria-label="Etape" matTooltip="Etape" matTooltipPosition="below" class="node-button node-step-button last-node">
            <fa-icon [icon]="stepIcon"></fa-icon>
        </div>

        <div
            #folderCreationTriggerDraggableElement
            draggable="true"
            aria-label="Trigger de création de dossier"
            matTooltip="Trigger de création de dossier"
            matTooltipPosition="below"
            class="node-button node-trigger-button">
            <fa-icon [icon]="faFolderPlus"></fa-icon>
        </div>

        <div
            #attributeUpdatedTriggerDraggableElement
            draggable="true"
            aria-label="Trigger de mise à jour d'attribut"
            matTooltip="Trigger de mise à jour d'attribut"
            matTooltipPosition="below"
            class="node-button node-trigger-button">
            <fa-icon [icon]="attributeIcon"></fa-icon>
        </div>

        <div
            #dateReachedTriggerDraggableElement
            draggable="true"
            aria-label="Trigger de date atteinte"
            matTooltip="Trigger de date atteinte"
            matTooltipPosition="below"
            class="node-button node-trigger-button">
            <fa-icon [icon]="dateReachIcon"></fa-icon>
        </div>

        <div
            #delayExpiredTriggerDraggableElement
            draggable="true"
            aria-label="Trigger de délai expiré"
            matTooltip="Trigger de délai expiré"
            matTooltipPosition="below"
            class="node-button node-trigger-button">
            <fa-icon [icon]="delayExpiredIcon"></fa-icon>
        </div>

        <div
            #timerTriggerDraggableElement
            draggable="true"
            aria-label="Minuteur"
            matTooltip="Minuteur"
            matTooltipPosition="below"
            class="node-button node-trigger-button last-node">
            <fa-icon [icon]="timerIcon"></fa-icon>
        </div>

        <div
            #sendMailActionDraggableElement
            draggable="true"
            aria-label="Action d'envoi de mail'"
            matTooltip="Action d'envoi de mail"
            matTooltipPosition="below"
            class="node-button node-action-button">
            <fa-icon [icon]="emailIcon"></fa-icon>
        </div>

        @if (smsSubscriptionEnabled) {
            <div
                #sendSmsActionDraggableElement
                draggable="true"
                aria-label="Action d'envoi de SMS'"
                matTooltip="Action d'envoi de SMS"
                matTooltipPosition="below"
                class="node-button node-action-button">
                <fa-icon [icon]="smsIcon"></fa-icon>
            </div>
        }

        <div
            #callApiActionDraggableElement
            draggable="true"
            aria-label="Action d'appel d'API"
            matTooltip="Action d'appel d'API"
            matTooltipPosition="below"
            class="node-button node-action-button">
            <fa-icon [icon]="apiCallIcon"></fa-icon>
        </div>

        <div
            #completeWorkflowActionDraggableElement
            draggable="true"
            aria-label="Action de finalisation du workflow"
            matTooltip="Action de finalisation du workflow"
            matTooltipPosition="below"
            class="node-button node-action-button">
            <fa-icon [icon]="workflowCompleteIcon"></fa-icon>
        </div>

        <div
            #updateAttributeActionDraggableElement
            draggable="true"
            aria-label="Action de mise à jour d'attribut"
            matTooltip="Action de mise à jour d'attribut"
            matTooltipPosition="below"
            class="node-button node-action-button">
            <fa-icon [icon]="attributeUpdateIcon"></fa-icon>
        </div>

        <div
            #flagUnreadActionDraggableElement
            draggable="true"
            aria-label="Action de passage du dossier en non-lu"
            matTooltip="Action de passage du dossier en non-lu"
            matTooltipPosition="below"
            class="node-button node-action-button">
            <fa-icon [icon]="unreadIcon"></fa-icon>
        </div>

        <div
            #stopTimerActionDraggableElement
            draggable="true"
            aria-label="Action d'arrêt de minuteur"
            matTooltip="Action d'arrêt de minuteur"
            matTooltipPosition="below"
            class="node-button node-action-button">
            <fa-icon [icon]="stopTimerIcon"></fa-icon>
        </div>

        <div
            #reminderCreationActionDraggableElement
            draggable="true"
            aria-label="Action de création de rappel"
            matTooltip="Action de création de rappel"
            matTooltipPosition="below"
            class="node-button node-action-button">
            <fa-icon [icon]="reminderCreationIcon"></fa-icon>
        </div>

        <div
            #archiveFolderActionDraggableElement
            draggable="true"
            aria-label="Action d'archivage de dossier"
            matTooltip="Action d'archivage de dossier"
            matTooltipPosition="below"
            class="node-button node-action-button">
            <fa-icon [icon]="archiveFolderIcon"></fa-icon>
        </div>
    </div>
    @if (validityReport) {
        <div class="validity-bar">
            @if (validityReport.isValid) {
                <button mat-raised-button class="default-button">Le workflow est valide</button>
            } @else {
                <button mat-raised-button color="warn">Le workflow n'est pas valide</button>
            }
            @if (validityReport.errors.length > 0) {
                <div
                    class="errors-counter"
                    [hubComponentTooltip]="WorkflowValidityReportViewerComponent"
                    [tooltipPosition]="'bottom'"
                    [tooltipData]="{ data: validityReport, type: 'Errors' }"
                    (tooltipEvent)="onValidityElementClick($event.elementType, $event.elementId)">
                    <span>{{ validityReport.errors.length }}</span>
                    <fa-icon [icon]="errorIcon" class="error-icon"></fa-icon>
                </div>
            }
            @if (validityReport.warnings.length > 0) {
                <div
                    class="warnings-counter"
                    [hubComponentTooltip]="WorkflowValidityReportViewerComponent"
                    [tooltipPosition]="'bottom'"
                    [tooltipData]="{ data: validityReport, type: 'Warnings' }"
                    (tooltipEvent)="onValidityElementClick($event.elementType, $event.elementId)">
                    <span>{{ validityReport.warnings.length }}</span>
                    <fa-icon [icon]="warningIcon" class="warning-icon"></fa-icon>
                </div>
            }
        </div>
    }
    <div class="actions-bar">
        <button
            mat-fab
            class="primary-button button-filter small"
            aria-label="Recentrer l'affichage"
            matTooltip="Recentrer l'affichage"
            matTooltipPosition="below"
            (click)="onRecenterClick()">
            <fa-icon [icon]="recenterIcon"></fa-icon>
        </button>
        <button
            mat-fab
            class="primary-button button-filter small"
            aria-label="Réorganiser l'affichage"
            matTooltip="Réorganiser l'affichage"
            matTooltipPosition="below"
            (click)="onRearrangeClick()">
            <fa-icon [icon]="rearrangeIcon"></fa-icon>
        </button>
        <button
            mat-fab
            class="primary-button button-filter small"
            aria-label="Rechercher un élément"
            matTooltip="Rechercher un élément"
            matTooltipPosition="below"
            (click)="onSearchClick()">
            <fa-icon [icon]="searchIcon"></fa-icon>
        </button>
        <button
            mat-fab
            class="primary-button button-filter small"
            aria-label="Gestion de l'affichage..."
            matTooltip="Gestion de l'affichage..."
            matTooltipPosition="below"
            [matMenuTriggerFor]="filterMenu">
            <fa-icon [icon]="filterIcon"></fa-icon>
        </button>
        <button
            mat-fab
            class="primary-button button-settings small"
            aria-label="Paramètres du workflow"
            matTooltip="Paramètres du workflow..."
            matTooltipPosition="below"
            (click)="onManageSettingsClick()">
            <fa-icon [icon]="settingsIcon"></fa-icon>
        </button>
    </div>
</div>

<mat-menu #filterMenu="matMenu" class="folders-filter-menu">
    <div class="filter-menu">
        <p class="menu-title">Visililité des éléments</p>
        @for (elementVisibility of elementVisibilities; track elementVisibility.type) {
            <div class="menu-item">
                <mat-checkbox
                    class="accent-button"
                    (change)="onElementVisibilityChange(elementVisibility.type, $event); $event.stopPropagation()"
                    (click)="$event.stopPropagation()"
                    checked="true">
                    {{ elementVisibility.label }}
                </mat-checkbox>
            </div>
        }
    </div>
</mat-menu>
